import React from "react";
import { Link } from "react-router-dom";
import classes from "./css/topbar.module.scss";

const TopBar = (props) => {
  return (
    <div className={classes.topInfoBar}>
      <div className="custom-container">
        <div className={classes.topText}>
          <a
            className={classes.topbarText}
            href={props.topbarText.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{props.topbarText.message}</span>
          </a>
          <div className={`${classes.headContactDetail} d-none d-lg-flex`}>
            
            
            <Link
              to={`${process.env.PUBLIC_URL}/locations`}
              className={classes.storeLocator}
            >
              <img
                src={
                  `${process.env.PUBLIC_URL}` +
                  "assets/images/new_template/images/traking.svg"
                }
                title=""
                alt=""
                width="20"
              />
              <span>Store Locator</span>
            </Link>
            <Link
              to={`${process.env.PUBLIC_URL}/sales/guest/form`}
              className={classes.orderTracking}
            >
              <img
                src={
                  `${process.env.PUBLIC_URL}` +
                  "assets/images/new_template/images/store-locator.svg"
                }
                alt=""
                width="20"
              />
              <span>Order Tracking</span>
            </Link>
            {/* <a
            href="https://api.whatsapp.com/send?phone=919961870099"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.whatsApp}
          >
            <img
              src={
                `${process.env.PUBLIC_URL}` +
                "assets/images/new_template/images/whatsapp-brands.svg"
              }
              alt=""
              width="15"
            />
            <span>WhatsApp</span>
          </a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
